import {
  createFileRoute,
  lazyRouteComponent,
  redirect,
} from '@tanstack/react-router';
import { z } from 'zod';

import { FEATURES, hasFeature } from '@/features/feature-flags';

// No view is the main list. Unknown params, such as another route's `new`, are dropped.
// `clearedSince` (epoch ms) opens History on the cards Littlebird cleared since then, as the Feed's banner counts them
export const feedSearchSchema = z.object({
  view: z.enum(['history']).optional().catch(undefined),
  clearedSince: z.number().int().nonnegative().optional().catch(undefined),
});

export const Route = createFileRoute('/_authenticated/feed/')({
  validateSearch: feedSearchSchema.parse,
  staticData: { headerTitle: 'page' },
  beforeLoad() {
    if (hasFeature(FEATURES.ACTION_CARDS_FEED)) return;
    throw redirect({ to: '/chats', search: {}, replace: true });
  },
  component: lazyRouteComponent(
    () => import('@/features/feed-lab'),
    'FeedScreen'
  ),
});
